export const NivelTensionEnum = {
  NIVEL_1: { id: 15, nombre: "Nivel 1" },
  NIVEL_2: { id: 16, nombre: "Nivel 2" },
  NIVEL_3: { id: 17, nombre: "Nivel 3" }
};
